import React, { useEffect } from 'react';

const GamePage: React.FC = () => {
  useEffect(() => {
    import('../phaser/Game');

  }, []);

return (
    <div
      id="game-container"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        padding: 0,
        margin: 0,
        backgroundColor: 'transparent',
        zIndex: 9999,
        overflow: 'hidden',
        borderRadius: 0, // optional, aber besser entfernt
      }}
    />
  );
};


export default GamePage;
